<template>
  <div
    @click="$emit('click')"
    @mouseenter="isHovering = true"
    @mouseleave="isHovering = false"
    class="projectcategory__icon rounded-lg pt-2 pb-2 pr-3 pl-3 w-100 text-left cursor-pointer"
    :class="{ 'bg-warning': isHovering, 'bg-white': !isHovering }"
  >
    <b-button variant="transparent" class="p-0">
      <img v-if="isHovering" src="@/assets/icons/plus-active.svg" width="15" height="15" />
      <img v-else src="@/assets/icons/plus.svg" width="15" height="15" />
    </b-button>

    <strong>
      <span :class="{ 'text-white': isHovering, 'text-warning': !isHovering }" class="pr-2 pl-2 text-uppercase  cursor-pointer">
        {{ name }}
      </span>
    </strong>
  </div>
</template>

<script>
export default {
  name: "Category",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isHovering: false,
  }),
};
</script>

<style lang="scss">
@import "@/assets/scss/_settings";

.projectcategory .base-dropdown {
  left: -15px !important;
  top: -5px !important;
}

.is-opened .projectcategory__icon {
  background-color: #151718 !important;
}
</style>
